import { useReducer } from 'react'
import { useTheme, Tab, Tabs } from '@mui/material'
import {
    UniversalCookieCrumb,
    DataGridLayout,
    TabPanel,
} from '../UniversalComponents'

import { useAuth } from '../../context/AuthenticationContext'
import Tickets from './Tickets'

const Support = () => {
    const reducer = (state, newState) => ({ ...state, ...newState })
    const { auth } = useAuth()
    const defaultState = {
        currentTab: 0,
        tabName: '',
    }

    const [state, setState] = useReducer(reducer, defaultState)

    const { currentTab, tabName } = state
    const tabs: String[] =
        auth && auth?.userProfile && auth?.userProfile?.superAdmin
            ? [
                  'Password Reset Tickets',
                  'Boat Issue Tickets',
                  'App Issue Tickets',
                  'Other Tickets',
              ]
            : []

    const setCurrentTab = (event: React.SyntheticEvent, newValue: number) =>
        setState({ currentTab: newValue, tabName: tabs[newValue] })

    const theme = useTheme()

    return (
        <DataGridLayout
            cookieCrumbs={<UniversalCookieCrumb customTitle={tabName} />}
            tabBar={
                <Tabs
                    value={currentTab}
                    onChange={setCurrentTab}
                    indicatorColor="secondary"
                    textColor="primary"
                    variant="scrollable"
                    aria-label="Osmosis"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    {tabs?.map((label, index) => (
                        <Tab
                            key={`tab-label-${label}-${index}`}
                            label={label}
                        />
                    ))}
                </Tabs>
            }
            dataGrid={
                <>
                    <TabPanel
                        value={currentTab}
                        index={0}
                        dir={theme.direction}
                    >
                        <Tickets ticketType="password reset" />
                    </TabPanel>
                    {tabs.length === 4 && (
                        <TabPanel
                            value={currentTab}
                            index={1}
                            dir={theme.direction}
                        >
                            <Tickets ticketType="boat issues" />
                        </TabPanel>
                    )}

                    <TabPanel
                        value={currentTab}
                        index={tabs?.length === 4 ? 2 : 1}
                        dir={theme.direction}
                    >
                        <Tickets ticketType="app issues" />
                    </TabPanel>
                    <TabPanel
                        value={currentTab}
                        index={tabs?.length === 4 ? 3 : 2}
                        dir={theme.direction}
                    >
                        <Tickets ticketType="other" />
                    </TabPanel>
                </>
            }
        />
    )
}

export default Support
